const sidebar = {
  section: {
    control: 'Monitoring',
    admin: 'Management',
  },
  myPage: 'My page',
  collapse: 'Collapse menu',
  expand: 'Expand menu',
  enterprise: {
    title: 'Enterprise Monitoring',
    dashboard: 'Enterprise Dashboard',
    factoryOverview: 'Factory Production Overview',
    dataflow: 'Data Collection Flow',
  },
  factory: {
    title: 'Factory Monitoring',
    overview: 'Factory Production Status',
    machineOverview: 'Machine Status',
    defectHistory: 'Defect History',
    realtimeShot: 'Realtime Shot Status',
  },
  machine: {
    title: 'Machine Monitoring',
    dashboard: 'Machine Dashboard',
    equipmentBoard: 'Equipment Board',
  },
  ai: {
    title: 'AI Analysis',
    analysis: 'AI Analysis',
    manage: 'AI Management',
  },
  management: {
    title: 'Factory / Equipment',
    factoryList: 'Factory List',
    factoryRegister: 'Register Factory',
    equipmentList: 'Equipment List',
    equipmentRegister: 'Register Equipment',
  },
  user: {
    title: 'User Management',
    list: 'User List',
    register: 'Register User',
    role: 'Role Management',
    notice: 'Notice Management',
  },
  system: {
    title: 'System',
    general: 'General Settings',
    monitoring: 'Monitoring Settings',
    alarm: 'Alarm Settings',
    dataCollection: 'Data Collection',
    log: 'System Log',
    ip: 'IP Management',
    labeling: 'Vision Labeling',
  },
  moduleb: {
    title: 'Module B Fusion Judgment',
    sync: 'Shot-Product Sync',
    features: 'Feature Extraction & Matching',
    fusion: '3-Modal Weighted Fusion',
    judgment: 'Overall Defect Judgment',
  },
  modulec: {
    title: 'Module C Autonomous Quality',
    recommend: 'Recommendation & Approval',
    safeguard: 'Safeguard',
  },
  platform: {
    title: 'Platform Admin',
    companies: 'Company Management',
    users: 'Global Users',
    status: 'System Status',
    licenses: 'License Management',
  },
};

export default sidebar;
